import { forwardRef } from 'react';
export function createUIElement(name, render) {
    var result = forwardRef(render);
    result.displayName = name;
    result.selector = ".vm-" + name;
    return result;
}
//# sourceMappingURL=createUIElement.js.map